import request from '@/libs/request';

export const labelComplexManagerQueryApi = (data) =>
  request('/api/labelComplex/manager/query', data);
export const EyaoSaaSSynCreateMaterialApi = (data) => request('BatchAddMaterial', data);
export const EyaoSaaSSelectMaterialApi = (data) => request('GetMaterialList', data);
export const EyaoSaaSDeleteMaterialApi = (data) => request('DelMaterial', data);
export const EyaoSaaSUpdateMaterialPubRefApi = (data) => request('EditMaterial', data);
// 根据素材id查询详细信息
export const GetMaterialByIDs = (data) => request('GetMaterialByIDs', data);
export const bannerInfoManagerModifyBannerInfoApi = (data) =>
  request('/api/bannerInfo/manager/modifyBannerInfo', data);
// 上下架文章
export const setArticleStatusApi = (data) => request('UpdateArticleStatus', data);
// 上架企业应用文章
export const EyaoSaaSTakeUpArticlesApi = (data) => request('EyaoSaaSTakeUpArticles', data);
// 下架企业应用文章
export const EyaoSaaSTakeDownArticlesApi = (data) => request('EyaoSaaSTakeDownArticles', data);
// 发布前校验
export const CheckArticlePublish = (data) => request('CheckArticlePublish', data);
// 发布到微信公众号号
export const publishArticleWeChatPageApi = (data) => request('PublishArticleToWechat', data);
// 发布到微信小程序
export const publishArticleToMiniApi = (data) => request('PublishArticleToMini', data);
// 文章发布
export const listPublishRecodeApi = (data) => request('ListPublishRecode', data);
// 获取文章列表
export const getArticleListApi = (data) => request('GetArticleList', data);
// 获取企业应用文章列表
export const EyaoSaaSQueryArticlesApi = (data) => request('EyaoSaaSQueryArticles', data);
// 根据id查询文章
export const GetArticleByIDApi = (data) => request('GetArticleByID', data);
// 新建文章(公众号)
export const AddArticleResApi = (data) => request('AddArticle', data);
// 更新文章(公众号)
export const UpdArticleResApi = (data) => request('UpdArticle', data);
// 新建文章(企业应用)
export const EyaoSaaSCreateArticleApi = (data) => request('EyaoSaaSCreateArticle', data);
// 更新文章(企业应用)
export const EyaoSaaSUpdateArticleApi = (data) => request('EyaoSaaSUpdateArticle', data);
// 根据id查询文章(企业应用)
export const EyaoSaaSGetArticleApi = (data) => request('EyaoSaaSGetArticle', data);
// XXX
export const userCountByAppIdAndStrategyIdApi = (data) => request('/', data);
// 单篇文章数据明细列表
export const getArticleStatByArtIDApi = (data) => request('GetArticleStatByArtID', data);
// 公众号记录的导出
export const ExportArticleRecords = (data) => request('ExportArticleRecords', data);
// 发布预览
export const preViewWechatMessageApi = (data) => request('PreViewWechatMessage', data);
// 文章发布快照详情
export const getPublishArticleWechatDetailApi = (data) =>
  request('GetPublishArticleWechatDetail', data);
// 发布到企业微信
export const updateEyaoSaaSWxArticlesPublicshSendApi = (data) =>
  request('EyaoSaaSWxArticlesPublicshSend', data);
// 查询发布列表
export const GetArticlePushList = (data) => request('GetArticlePushList', data);
// 撤回发布
export const ArticlePushReallocate = (data) => request('ArticlePushReallocate', data);
// 取消发布
export const ArticleCancelPush = (data) => request('ArticleCancelPush', data);
// 读取被删除的媒体文件数据
export const getDeletedMediaListApi = (data) => request('GetDeletedMediaList', data);
/** 运营位设置 */
/* 查询横幅列表，即将被废弃 */
export const getBannerListApi = (data) => request('GetBannerList', data);
// 新的查询banner接口
export const GetBanners = (data) => request('GetBanners', data);
/* 上下线横幅 */
export const offlineBannerApi = (data) => request('OfflineBanner', data);
/* 删除横幅 */
export const deleteBannerApi = (data) => request('DelBanner', data);
/* 读取横幅数量上限 */
export const getBannerLimitApi = (data) => request('GetBannerLimit', data);
/* 新增banner */
export const addBannerApi = (data) => request('AddBanner', data);
/* 读取横幅信息 */
export const getBannerByIDApi = (data) => request('GetBannerByID', data);
/* banner排序 */
export const updateSortApi = (data) => request('RemoveSort', data);
/* 获取药企基本信息 */
export const getCompanyInfoApi = (data) => request('GetCompanyInfo', data);

/* 投票管理 */
// 投票列表
export const GetVoteListApi = (data) => request('GetVoteList', data);
/* 删除投票 */
export const DelVoteApi = (data) => request('DelVote', data);
/* 读取投票详情 */
export const GetVoteByIDApi = (data) => request('GetVoteByID', data);
/* 新增投票 */
export const AddVoteApi = (data) => request('AddVote', data);
/* 编辑投票 */
export const modifyVotesInfoApi = (data) => request('/api/vote/manager/modifyVotesInfo', data);
/* 更新投票截止时间 */
export const UpdVoteEndtimeApi = (data) => request('UpdVoteEndtime', data);
/* 导出投票信息 */
export const ExportVoteInfoApi = (data) => request('ExportVoteInfo', data);
/* 读取投票状态枚举 */
export const GetVoteStatusCfgApi = (data) => request('GetVoteStatusCfg', data);

/**
 * 文档管理
 */
/* 查询空间使用量 */
export const GetSpaceInfo = (data) => request('GetSpaceInfo', data);
/* 查询文档详情 */
export const GetDocInfo = (data) => request('GetDocInfo', data);
/* 查询文档列表 */
export const GetDocList = (data) => request('GetDocList', data);
/* 上传文档（包含断点续传） */
export const UploadDoc = (data) => request('UploadDoc', data);
/* 修改文档名称 */
export const RenameDoc = (data) => request('RenameDoc', data);
/* 删除文档 */
export const DelDoc = (data) => request('DelDoc', data);
/* 下载文档 */
export const DownloadDoc = (data) => request('DownloadDoc', data);
/* 复制文档链接 */
export const CopyDocUrl = (data) => request('CopyDocUrl', data);
/* 查看文档使用日志 */
export const GetDocLog = (data) => request('GetDocLog', data);
/* 导出文档使用日志 */
export const GetLogExcel = (data) => request('GetLogExcel', data);
/* 查询文档格式列表 */
export const GetDocTypeList = (data) => request('GetDocTypeList', data);
/* 获取全量标签 */
export const GetAllLabelInfoList = (data) => request('GetAllLabelInfoList', data);
